import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import "./About.css";

import img1 from "../assets/about1.jpg";
import img2 from "../assets/about2.jpg";
import img3 from "../assets/about3.jpg";
import img4 from "../assets/about4.jpg";
export default function About() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTours = () => {
    if (location.pathname !== "/") {
      // If not on homepage, navigate there first
      navigate("/", { replace: false });
      setTimeout(() => {
        scroller.scrollTo("tours", { smooth: true, offset: -70, duration: 500 });
      }, 100); // slight delay to allow page to render
    } else {
      scroller.scrollTo("tours", { smooth: true, offset: -70, duration: 500 });
    }
  };

  return (
    <section id="about" className="about-section">
      <div className="about-wrapper">

        {/* LEFT — TEXT */}
        <div className="about-left">
          <h2>About Gjirokaster & Our Tours</h2>

          <p className="about-intro">
           Gjirokaster is one of Albania’s most beautiful and historic cities. 
           <br></br>Known as the “City of Stone,” it is famous for its traditional houses, cobblestone streets, and breathtaking castle views.
          </p>

  <p>
  Declared a UNESCO World Heritage Site, Gjirokaster offers a unique blend of Albanian history, rich culture, and authentic local life.
  <br /><br />
  Our tours help you discover:
  <br /><br />

  <span className="check-icon">
    <svg viewBox="0 0 24 24" >
      <path d="M7 13l5 5 7-10" />
    </svg>
  </span>
  Rich History
  <br />

  <span className="check-icon">
    <svg viewBox="0 0 24 24" >
      <path d="M7 13l5 5 7-10" />
    </svg>
  </span>
  Unique Architecture
  <br />

  <span className="check-icon">
    <svg viewBox="0 0 24 24" >
      <path d="M7 13l5 5 7-10" />
    </svg>
  </span>
  Local Traditions
  <br />

  <span className="check-icon">
    <svg viewBox="0 0 24 24" >
      <path d="M7 13l5 5 7-10" />
    </svg>
  </span>
  Culture & Legends
  <br />

  <span className="check-icon">
    <svg viewBox="0 0 24 24" >
      <path d="M7 13l5 5 7-10" />
    </svg>
  </span>
  Everyday Local Life
  <br />
   <span className="check-icon">
    <svg viewBox="0 0 24 24" >
      <path d="M7 13l5 5 7-10" />
    </svg>
  </span>
  Hidden Gems Most Tourists Miss
</p>
          <p style={{fontStyle:'italic'}}>
          “Our mission is to share the beauty, history, and stories of Gjirokaster with every visitor. We aim to provide authentic, engaging, and memorable experiences that connect travelers with the soul of the city, its architecture, culture, and people while supporting local guides and communities.”
          </p>

          {/* Updated button */}
          <button className="about-btn" onClick={scrollToTours}>
            Learn More About Our Tours
          </button>
        </div>

        {/* RIGHT — IMAGES */}
        <div className="about-right">
          <div className="about-images">
            <img src={img1} alt="Gjirokastra Old Town" />
            <img src={img2} alt="Stone houses of Gjirokastra" />
            <img src={img3} alt="Gjirokastra Castle view" />
            <img src={img4} alt="Gjirokastra Castle view" />
          </div>
        </div>

      </div>
    </section>
  );
}
